import * as Yup from "yup";

export const SignupSchema = Yup.object().shape({
  nombre: Yup.string().required("El nombre es requerido"),
  apellidos: Yup.string().required("Los apellidos son requeridos"),
  email: Yup.string().email("Email inválido").required("El email es requerido"),
  telefono: Yup.string().required("El teléfono es requerido"),
  foto: Yup.string().required("La foto es requerida"),
});
